import React from "react"
import { Button, DialogActions, DialogContent, DialogTitle, useTheme } from "@mui/material"
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined"
import { useResponsive } from "src/utils/useResponsive"
import { ColoredDialog } from "src/components/ColoredDialog"

interface TwoOptionsDialogProps {
  open: boolean
  color: "warning" | "primary"
  title: string
  content: React.ReactNode
  firstOptionText: string
  secondOptionText: string
  firstOptionAction: () => void
  secondOptionAction: () => void
  onClose?: () => void
  sizeForMobile?: "small" | "medium"
}

const TwoOptionsDialog: React.FC<TwoOptionsDialogProps> = ({
  open,
  color,
  title,
  content,
  firstOptionText,
  secondOptionText,
  firstOptionAction,
  secondOptionAction,
  sizeForMobile
}) => {
  const { spacing } = useTheme()
  const { isMobile } = useResponsive()
  return (
    <ColoredDialog
      open={open}
      color={color}
      disableScrollLock
      fullScreen={isMobile}
      sx={{ py: sizeForMobile === "small" ? 4 : 8, px: 4 }}
    >
      <DialogContent
        sx={{ pt: sizeForMobile === "small" ? 4 : 8, pb: 0, px: 4, minWidth: { xs: "auto", md: 400, lg: 450 } }}
      >
        <DialogTitle variant="h4">
          {color === "warning" && <WarningAmberOutlined />}
          {title}
        </DialogTitle>
        {content}
      </DialogContent>
      <DialogActions
        sx={{
          p: sizeForMobile === "small" ? 2 : 4,
          flexDirection: { xs: sizeForMobile === "small" ? "row" : "column", md: "row" },
          gap: { xs: 1, md: 0 }
        }}
      >
        <Button variant="contained" color={color} onClick={firstOptionAction} fullWidth={isMobile}>
          {firstOptionText}
        </Button>
        <Button variant="outlined" color={color} onClick={secondOptionAction} fullWidth={isMobile}>
          {secondOptionText}
        </Button>
      </DialogActions>
    </ColoredDialog>
  )
}
export default TwoOptionsDialog
